import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { CurrentHotelService } from './current-hotel.service';
import { Hotel } from '../models/view-models/hotel';

/**
 * @deprecated Use CurrentHotelService instead.
 * This service is maintained for backward compatibility and delegates to CurrentHotelService.
 */
@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  /**
   * @deprecated Use CurrentHotelService.currentHotel$ or CurrentHotelService.currentHotel instead.
   */
  get currentHotel(): BehaviorSubject<Hotel | null> {
    return this.hotelService.currentHotelSubject;
  }

  constructor(private hotelService: CurrentHotelService) {
    // Note: Unlike the old implementation, we don't auto-fetch on construction.
    // The LoginComponent calls initCurrentHotel() explicitly after login.
  }

  /**
   * @deprecated Use CurrentHotelService.loadCurrentHotel() instead.
   */
  async initCurrentHotel(): Promise<void> {
    await this.hotelService.loadCurrentHotel();
  }

  /**
   * @deprecated Use CurrentHotelService.setCurrentHotel() instead.
   */
  public setCurrentHotel(hotel: Hotel): void {
    this.hotelService.setCurrentHotel(hotel);
  }

  /**
   * @deprecated Use CurrentHotelService.getCurrentHotel() or .currentHotel instead.
   */
  public getCurrentHotel(): Hotel {
    return this.hotelService.getCurrentHotel() as Hotel;
  }
}
